import HTTP from "../utils/HTTP";

class SponsoredService {
  fetchSponsorKidsByMentor = (user_id, email, options = {}) => {
    if (options.allForSuperAdmin) {
      return HTTP.get("/admin/sponsor/kids", { params: { all: true } });
    }
    const params = {};
    if (user_id) params.mentor_id = user_id;
    if (email) params.email = email;
    return HTTP.get("/admin/sponsor/kids", { params });
  };

  updateKidToBeSponsor = (data) => {
    return HTTP.put("/admin/sponsor/kid/status-to-be-sponsor", data);
  };
  addSponsor = (data) => {
    return HTTP.post("/admin/sponsor/add", data);
  };
}

export default new SponsoredService();
